let cn = {
    RESETPWD: "重置密码",
    LOADING: "正在重置…",
    NOACC: "还没有账号",
    PLEASEINPUTPASS: "请输入密码",
    PLEASEINPUTREPASS: "请再次输入密码",
    DIFFERENT: "两次输入的密码不一样",
    ACCOUNTNAME: "用户账号",
    PASSWORD: "密码",
    RESET_PASSWD: "确认密码",
    CAPTCHA: "验证码",
    PLEASEINPUTCAPTCH: "请输入验证码",
    RE_SET: "重 置",
    TIP: "留空则不修改密码",
    SUCC_TIP: "验证成功，谢谢",
    CONFIRM: "确定",
};
let tw = {
    RESETPWD: "重置密碼",
    LOADING: "正在重置…",
    PLEASEINPUTPASS: "請輸入密碼",
    PLEASEINPUTREPASS: "請再次輸入密碼",
    DIFFERENT: "兩次輸入的密碼不一樣",
    ACCOUNTNAME: "用戶賬號",
    PASSWORD: "密碼",
    RESET_PASSWD: "確認密碼",
    CAPTCHA: "驗證碼",
    PLEASEINPUTCAPTCH: "請輸入驗證碼",
    RE_SET: "重 置",
    TIP: "留空則不修改密碼",
    SUCC_TIP: "驗證成功，謝謝",
    CONFIRM: "確定",
};
let en = {
    RESETPWD: "Reset Password",
    LOADING: "Resetting…",
    PLEASEINPUTPASS: "Please enter your password",
    PLEASEINPUTREPASS: "Please enter your password again.",
    DIFFERENT: "The two passwords entered must be identical",
    ACCOUNTNAME: "Username",
    PASSWORD: "Password",
    RESET_PASSWD: "Confirm Password",
    CAPTCHA: "Verification Code",
    PLEASEINPUTCAPTCH: "Please enter the verification code",
    RE_SET: 'Reset',
    TIP: "Leave blank without changing password",
    SUCC_TIP: "The supplier verification is done, thank you",
    CONFIRM: "OK",
}

export {
    cn,
    tw,
    en
}